import { Container, Row, Col, Button } from "react-bootstrap";
import { coursesIcon, downloadICon, galaxyIcon, scrollDownIcon } from "../../../constants/icons";
import studentImage from "../../../assets/images/student.png";

function HomeIntroSection({ onClick }) {

    return (
        <div className="home-intro-section">
            <Container>
                <Row>
                    <Col xl={4} xxl={5}>
                        <div className="home-intro-info">
                            <h2>Unlock your potential with <span>Examally</span>, your personalized path to success!</h2>
                            <p>Examally is a cutting-edge platform that creates and organizes personalized study materials to enhance your learning for the Leaving Cert exams.</p>
                            <div className="button-wrap">
                                <Button variant="primary">Try it Free!</Button>
                                <Button variant="outline-primary">Learn more</Button>
                            </div>
                        </div>
                        <div className="scroll-down-btn">
                            Scroll
                            <span role="button" onClick={onClick}>{scrollDownIcon}</span>
                        </div>
                    </Col>
                    <Col xl={8} xxl={7}>
                        <div className="circle-wrapper">
                            <div className="circle-container">
                                <div className="galaxy-icon">
                                    {galaxyIcon}
                                </div>

                                <div className="circle">
                                    <img src={studentImage} alt="Student with Laptop" className="student-image" />
                                </div>
                            </div>
                            <div className="circle-box-holder">
                                <div className="print-exam-box" role="button">
                                    {downloadICon}
                                    <span>Printable Exam Paper</span>
                                </div>
                                <div className="courses-count" role="button">
                                    {coursesIcon}
                                    <span>19 Courses</span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default HomeIntroSection;